import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Dialog } from '@mui/material';

import SelfEmployedUploader from './SelfEmployedUploader';

import '../../../commonStyles/muiStyles.css';
import modal from '../../../commonStyles/modal.module.css';

const SelfEmployedExtractionModal = ({ isOpen, onClose }) => {
    const [uploadDocuments, setUploadDocuments] = useState(true);

    const onFormExit = () => {
        setUploadDocuments(false);
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={isOpen} fullWidth className="muiDialogWrapper">
            <div className={modal.modalHeader}>
                <h3>Self Employed Coach - Approval to Paid Extraction from Upload</h3>
            </div>
            <div className={modal.modalNonFormContent}>
                <SelfEmployedUploader
                    isOpenUploader={uploadDocuments}
                    onCancel={onClose}
                    onExit={onFormExit}
                />
            </div>
        </Dialog>
    );
};

SelfEmployedExtractionModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func
};

export default SelfEmployedExtractionModal;
